import {format} from "date-fns";

export const formatDate = (date: Date) => date ? format(new Date(date), 'MM.dd.yyyy kk:mm:ss') : '---';

